/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import ModuleTabs from './ModuleTabs';
import ChunkErrorBoundary from './ChunkErrorBoundary';
import HeaderDropdown from './HeaderDropdown';
import WecomLoginButton from './WecomLoginButton';
import WecomJssdk from './WecomJssdk';
import CommonBindModal from './CommonBindModal/index';
import NotifyBell from './NotifyBell';
import FilterModal from './FilterModal';

// 导出所有组件
export { default as WecomLoginButton } from './WecomLoginButton';
export { default as WecomJssdk } from './WecomJssdk';
export { default as CommonBindModal } from './CommonBindModal/index';
export { default as NotifyBell } from './NotifyBell';
export { default as FilterModal } from './FilterModal';
export type {
  FilterModalProps,
  FilterField,
  FilterCondition,
  FieldValueType,
  SelectOption,
} from './FilterModal';
export { MatchType, MATCH_TYPE_OPTIONS } from './FilterModal';

// 导出从其他模块导入的组件
export { default as Footer } from './Footer';
export { default as HeaderDropdown } from './HeaderDropdown';
export { default as ModuleTabs } from './ModuleTabs';
export { default as OperationLog } from './OperationLog';
export { default as ChunkErrorBoundary } from './ChunkErrorBoundary';

// 导出RightContent的子组件
export { Question, SelectLang } from './RightContent';
export { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
